<template>
  <div>
    <va-icon name="local_library" size="26px" color="blank" style="margin-right: 4px;"/>

    <b style="margin-left:3px;">精华帖</b>
  </div>
  <div class="row content-list">
    <div class="flex operation-content invitation" v-for="(item,idx) in tableData" :key="idx">
      <!-- <img :src="item.userPhoto" alt="" class="user-photo"> -->
      <img :src="item.HeadPic || require('@/static/images/headDefault.jpg')" alt="" class="user-photo">
      <div>
        <div style="position:relative;padding-right: 16px;">
          <router-link :to="{path:'/admin/forum/postsPage/postsContent',query:{searcharticle:item.ID}}" class="link-a"
            tag="a">{{ item.Title }}
          </router-link>
          <div class="boutique"></div>
        </div>
        <div>
          <router-link to="" style="font-size: 13px;
    color: #333;">[{{ item.LabelName != null ? item.LabelName.slice(0, -1) : '' }}]
          </router-link>
          <span class="user-name">{{ item.alias }}</span>
          <!-- <span class="user-name">{{item.status}}</span> -->
          <span class="user-name">{{ item.CreateTime }}</span>
        </div>

      </div>
      <div>
        <span class="bubble">{{ item.ReplyCount }}</span>
      </div>
    </div>
  </div>
  <div>
    <vxe-pager
      background
      v-model:current-page="tablePager.currentPage"
      v-model:page-size="tablePager.pageSize"
      :total="tablePager.totalResult"
      @page-change="handlePageChange"
      :layouts="['PrevJump', 'PrevPage','Jump','PageCount', 'NextPage', 'NextJump','Total']">
    </vxe-pager>
  </div>
</template>
<script>
import {reactive} from 'vue';
import Qs from 'qs'

export default {
  name: "invitation",
  components: {},
  data() {
    const tablePager = reactive({
      currentPage: 1,
      pageSize: 10,
      totalResult: 0
    })
    const toolbar = reactive({
      loading: false,
      formData: {
        searchKey: ''
      }
    })
    return {
      tableData: null,
      tablePager,
      toolbar,
      dataList: []
    }
  },
  mounted() {
    this.findData()
  },
  methods: {
    findData() {
      const params = {
        // 'uid': this.$store.state.userID,
        // 'email': this.$store.state.email,
        'currentPage': this.tablePager.currentPage,
        'pageSize': this.tablePager.pageSize,
        // 'searchKey': [this.toolbar.formData.searchKey]
      };
      this.$api.formsAPI.getEliteArticle(Qs.stringify(params))
        .then(res => {
          if (res.data.Success == false) {
            VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
            return;
          }
          // console.log(res.data.Data);
          this.tableData = res.data.Data.dataTable;
          this.tablePager.currentPage = res.data.Data.currentPage;
          this.tablePager.pageSize = res.data.Data.pageSize;
          this.tablePager.totalResult = res.data.Data.totalResult;

        })
        .catch(error => {
          console.log(error);

        })
    },
    handlePageChange() {
      this.findData();
    },
  },
}
</script>

<style scoped lang="scss">
.content-list {
  position: relative;
  height: 300px;
  align-items: start;
  flex-direction: column;
  overflow-y: scroll;
  flex-wrap: nowrap;
}

.bubble {
  position: relative;
  display: inline-block;
  vertical-align: middle;
  margin-left: 6px;
  padding: 3px 5px;
  background-color: #f0f7ff;
  border-radius: 4px;
  font-size: 13px;
  color: #333;
  line-height: normal;
}

.bubble::before {
  content: "";
  position: absolute;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
  left: -8px;
  display: inline-block;
  width: 0;
  height: 0;
  border-width: 4px;
  border-style: solid;
  border-color: transparent #ebf2fa transparent transparent;
}

.sanjiao {
  padding: 2px 4px;

  border-radius: 4px;
  font-size: 12px;
  color: rgb(51, 51, 51);
  background: rgb(240, 247, 255);
  position: absolute;
  right: 2px;
}

.sanjiao::before {
  content: "";
  width: 0px;
  height: 0px;
  border-width: 0px 8px 8px;
  border-style: solid;
  border-color: transparent transparent rgb(240, 247, 255);
  display: block;
  transform: rotate(-90deg);
  position: relative;
  position: absolute;
  left: -10px;
  top: 6px;
}

.invitation {

  .boutique::after {
    content: "精";
    display: block;
    position: absolute;
    right: -7px;
    top: 0;
    line-height: 12px;
    text-align: center;
    padding: 3px;
    border-radius: 4px;
    font-size: 12px;
    color: #ffffff;
    background: #fa8429;
  }

  align-items: flex-end;
  display: flex;

  .link-a {
    position: relative;
    width: 194px;
    font-weight: 800;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: block;
  }

  .user-name {
    color: #999;
    margin-left: 8px;
    font-size: 12px;
  }

  .user-photo {
    display: inline-block;
    vertical-align: top;
    width: 38px;
    height: 38px;
    margin-right: 10px;
    border-radius: 50%;
  }
}

@media (min-width: 768px) {
  .invitation .link-a {
    max-width: none;
  }

}

@media (min-width: 1200px) {
  .invitation .link-a {
    max-width: 194px;
  }
  .content-list {
    height: 430px;
  }
}
</style>
